import styles from "./FabButton.module.scss";
import React, {useState} from "react";
import ClickAwayListener from "react-click-away-listener";
import clsx from "clsx";

export const FabButton = ({actions = [], icon = "add", onClick = null}) => {
  const [fabOpened, setFabOpened] = useState(false);

  return <ClickAwayListener onClickAway={() => setFabOpened(false)}>
    <div className={clsx(styles.fabContainer, fabOpened ? styles.fabOpened : null)}>
      {actions.length > 0 && <div className={styles.fabActions}>
        {actions.map(action => {
          return <FabAction key={action.icon} action={action} onClicked={() => setFabOpened(false)}/>
        })}
      </div>}

      <button className={styles.fabButton} onClick={() => onClick ? onClick() : setFabOpened(prev => !prev)}>
        <span className="material-icons">{icon}</span>
      </button>
    </div>
  </ClickAwayListener>
}

const FabAction = ({action, onClicked}) => {
  return <button className={styles.fabAction} onClick={() => {
    onClicked();

    action.onClick();
  }}
  >
    <div className={styles.fabActionLabel}>{action.label}</div>

    <div className={clsx(styles.fabActionIcon, action.color ? styles[action.color] : "")}>
      <span className="material-icons">{action.icon}</span>
    </div>
  </button>
};
